export default "__VITE_ASSET__BpJfOx90__"